import PropTypes from 'prop-types'
import React from 'react'

const Stars = ({ stars, className, starWidth, starHeight }) => (
  <div className={className} role='img'>
    {stars.map(({ image, alt }, index) => (
      <img key={index} aria-hidden className='star' src={image} alt={alt} width={starWidth} height={starHeight} />
    ))}
  </div>
)

Stars.propTypes = {
  className: PropTypes.string,
  stars: PropTypes.arrayOf(PropTypes.shape({
    alt: PropTypes.string.isRequired,
    image: PropTypes.string
  })).isRequired,
  starWidth: PropTypes.number.isRequired,
  starHeight: PropTypes.number.isRequired
}

export default Stars
